import { useMutation } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import getFileExtension from "../../../shared/utils/getFileExtension";

export const createSocialMediaPost = async (data) => {
  const form = new FormData();
  const { files, ...rest } = data;
  const contentBlob = new Blob([`${JSON.stringify(rest)}`], {
    type: "application/json",
  });

  form.append("content", contentBlob);
  var i = 0;
  if (files) {
    for (let file of files) {
      console.log(getFileExtension(file?.name));
      const fileBlob = new Blob([file], { type: file?.type });
      form.append(
        "file",
        fileBlob,
        i === 0 && data.contentType === "IMAGEM"
          ? "Capa do POST.jpg"
          : file?.name
      );
      i += 1;
    }
  }

  const res = await axios.apiCadernoVirtual.post(
    "/socialmedia-service/post",
    form
  );
};

export const useCreateSocialMediaPost = ({ config } = {}) => {
  return useMutation({ ...config, mutationFn: createSocialMediaPost });
};
